<ion-toolbar class="toolbar" color="primary">
  <ion-buttons slot="start">
    <ion-menu-button menu="custom" [autoHide]="false">
      <app-image class="header__menu-icon" src="assets/icon/menu.svg" [alt]="'ALT_IMG.MENU' | translate"></app-image>
    </ion-menu-button>
  </ion-buttons>

  <ion-title class="header__title">
    {{ title | translate }}
  </ion-title>
</ion-toolbar>